import { Query } from 'graphql/generated/graphqlTypes';
import { mockVisitorGroupsInstallersAndCleaners } from 'mocks/graphqlMocks/visitorGroupFixtures';

export function mockedGetVisitorGroupsWithoutNestedResolversData(
  getVisitorGroupsForTenant: Query['getVisitorGroupsForTenant']
): Pick<Query, 'getVisitorGroupsForTenant'> {
  return { getVisitorGroupsForTenant };
}

export const mockedGetVisitorGroupsWithoutNestedResolversDataForQuery =
  mockedGetVisitorGroupsWithoutNestedResolversData(mockVisitorGroupsInstallersAndCleaners);
